<template>
  <b-row>
    <b-col v-if="!showForm" cols="12">
      <FilterCompoents :tipo="TIPO_EMPRESTIMO" @filtrarComponent="filtrar" />
    </b-col>
    <b-col cols="12">
      <b-card v-if="!showForm" title="Emprestimo">
        <div class="custom-search d-flex justify-content-start">
          <b-button
            v-if="verificarPermissao('ROLE_FINAN_INSERIR')"
            variant="primary"
            @click="addNew()"
          >
            Incluir
          </b-button>
        </div>
        <div class="custom-search d-flex justify-content-end">
          <b-form-group>
            <div class="d-flex align-items-center">
              <label class="mr-1">{{ $t("Search") }}</label>
              <b-form-input
                v-model="searchTerm"
                placeholder="Search"
                type="text"
                class="d-inline-block"
                @input="handleSearch"
              />
            </div>
          </b-form-group>
        </div>
        <vue-good-table
          mode="remote"
          :columns="columns"
          :rows="listaParcelamentos"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
          :total-rows="totalRecords"
          :is-loading.sync="isLoading"
          @on-sort-change="onSortChange"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Action -->
            <span v-if="props.column.field === 'action'">
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    v-if="verificarPermissao('ROLE_FINAN_ATUALIZAR')"
                    @click="edit(props.row)"
                  >
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>Edit</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="verificarPermissao('ROLE_FINAN_DELETAR')"
                    @click="remove(props.row)"
                  >
                    <feather-icon icon="TrashIcon" class="mr-50" />
                    <span>Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="tableConfigs.size"
                  :options="[tableConfigs.size]"
                  class="mx-1"
                  @input="handleChangePage"
                />
                <span class="text-nowrap">
                  of {{ tableConfigs.totalPages }} entries
                </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="tableConfigs.totalElements"
                  :per-page="tableConfigs.size"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @change="handleChangePage"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card>
      <FormEmprestimo v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import {
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BPagination,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import mixinsGlobal from "@/mixins";
import FilterCompoents from "@/layouts/components/FilterComponents.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import _ from "lodash";
import FormEmprestimo from "../form/EmprestimoForm.vue";

export default {
  name: "ContasEmprestimo",
  components: {
    BRow,
    BCol,
    TableComponents,
    FormEmprestimo,
    FilterCompoents,
    VueGoodTable,
    BCard,
    BFormSelect,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormInput,
    BButton,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("combosModule", {
      comboFormaPagamento: (state) => state.comboFormaPagamento,
      comboTipoPagamento: (state) => state.comboTipoPagamento,
    }),
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  data() {
    return {
      TIPO_EMPRESTIMO: 2,
      listaParcelamentos: [],
      tableConfigs: {
        last: false,
        totalPages: 5,
        totalElements: 41,
        size: 10,
        number: 0,
      },
      pageConfig: {
        page: 0,
        size: 10,
        sort: "descricao",
        order: "asc",
      },
      pageLength: 10,
      isLoading: false,
      totalRecords: 0,
      searchTerm: "",
      ehAssociado: false,
      showCpfAssociado: true,
      showForm: false,
      columns: [
        {
          label: "Id",
          field: "id",
          sortable: false,
        },
        {
          label: "Número",
          field: "numero",
          sortable: false,
        },
        {
          label: "Data Lançamento",
          field: "dataLancamento",
          formatFn: this.formatDateGrid,
          sortable: false,
        },
        {
          label: "Nome",
          field: "registro.nome",
          sortable: false,
        },
        {
          label: "Descrição",
          field: "descricao",
          sortable: false,
        },
        {
          label: "Confirmado",
          field: "confirmado",
          formatFn: this.formatColumBoolean,
          sortable: false,
        },
        {
          label: "Cancelado",
          field: "cancelado",
          formatFn: this.formatColumBoolean,
          sortable: false,
        },
        {
          label: "Valor Total",
          field: "valorTotal",
          formatFn: this.formatCurrencyBrazil,
          sortable: false,
        },

        {
          label: this.$t("Action"),
          field: "action",
          sortable: false,
        },
      ],
      objectFormInsert: {
        titleForm: "Cadastro de Emprestimo",
      },
      filter: {},
    };
  },
  async mounted() {
    this.listaParcelamentos = [];
    this.filterDefault();
    this.filtrar(this.filter);
  },
  methods: {
    filterDefault() {
      const locale = "pt-br";
      const date = new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const firstDayDate = firstDay.toLocaleDateString(locale);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const lastDayDate = lastDay.toLocaleDateString(locale);
      this.filter = {
        tipo: this.TIPO_EMPRESTIMO,
        dataInicio: firstDayDate,
        dataFinal: lastDayDate,
        situacao: -1,
        campo: "",
        renegociacao: !!this.$route.meta.renegociacao,
      };
    },
    handleSearch: _.debounce(async function (searching) {
      this.pageConfigdefault();
      if (searching) {
        this.pageConfig.filter = `descricao=${searching}`;
      }
      const result = await this.$store.dispatch(
        "parcelamentoFinananceiroModule/load",
        this.pageConfig,
      );
      this.pageConfig.page = result.data.pageable.pageNumber;
      this.tableConfigs.last = result.data.last;
      this.tableConfigs.totalPages = result.data.totalPages;
      this.tableConfigs.totalElements = result.data.totalElements;
      this.tableConfigs.size = result.data.size;
      this.tableConfigs.number = result.data.number;
      this.isLoading = false;
    }, 300),
    pageConfigdefault() {
      this.pageConfig = {
        check: false,
        page: 0,
        size: 10,
        sort: "descricao",
        order: "asc",
      };
    },
    handleChangePage(page) {
      this.pageConfig.page = page;
      this.loadTable(this.pageConfig);
    },
    onSortChange(params) {
      this.pageConfigdefault();
      this.pageConfig.sort = params[0].field;
      this.pageConfig.order = params[0].type;
      const obj = {
        filter: this.filter,
        pageConfig: this.pageConfig,
      };
      this.loadTable(obj);
    },
    async filtrar(val) {
      this.filter = val;
      this.isLoading = true;
      val.tipo = this.TIPO_EMPRESTIMO;
      val.renegociacao = !!this.$route.meta.renegociacao;
      const obj = {
        filter: val,
        pageConfig: this.pageConfig,
      };
      this.loadTable(obj);
    },
    async loadTable(obj) {
      this.isLoading = true;
      const result = await this.$store.dispatch(
        "parcelamentoFinananceiroModule/filterPayment",
        obj,
      );
      this.pageConfig.page = result.data.pageable.pageNumber;
      this.tableConfigs.last = result.data.last;
      this.tableConfigs.totalPages = result.data.totalPages;
      this.tableConfigs.totalElements = result.data.totalElements;
      this.tableConfigs.size = result.data.size;
      this.tableConfigs.number = result.data.number;
      this.listaParcelamentos = result.data.content;
      this.isLoading = false;
    },
    async addNew() {
      await this.$store.dispatch("combosModule/loadComboFormaPagamento");
      await this.$store.dispatch("combosModule/loadComboTipoPagamento");
      this.showForm = true;
      this.$nextTick(() => {
        if (this.$route.meta.renegociacao) {
          // Lógica para sinalizar ao form que é renegociação se necessário
          // Como o EmprestimoForm é injetado via v-else, ele pegará o estado se compartilhado ou via prop
        }
      });
    },
    async edit(data) {
      const routeName = this.$route.meta.renegociacao
        ? "editnegociacao"
        : "editemprestimo";
      this.$router.push({ name: routeName, params: { id: data.id } });
    },
    async cancelar() {
      this.showForm = false;
    },
    prepareForSave(data) {
      const objectSave = JSON.parse(JSON.stringify(data));
      const obj = {
        id: objectSave.id,
        registro: objectSave.registro,
        descricao: objectSave.descricao,
        dataLancamento: objectSave.dataLancamento,
        dataVencimento: objectSave.dataVencimento,
        dataQuitacao: objectSave.dataQuitacao,
        valor: objectSave.valor,
        desconto: objectSave.desconto,
        juro: objectSave.juro,
        multa: objectSave.multa,
        valorTotal: objectSave.valor,
        valorQuitado: objectSave.valorQuitado,
        obs: objectSave.obs,
        tipo: {
          id: objectSave.tipo,
        },
        formaPagamento: {
          id: objectSave.formaPagamento,
        },
        conta: objectSave.conta
          ? {
              id: objectSave.conta,
            }
          : null,
        situacao: objectSave.situacao,
        ativo: objectSave.ativo,
      };
      return obj;
    },
    async save(data) {
      if (!data.registro.id) {
        this.MensagemError("Digite um CPF cadastrado!");
        return;
      }
      const objectSave = this.prepareForSave(data);
      this.$store
        .dispatch(
          "parcelamentoFinananceiroModule/insertNewPagamentoRecebimento",
          objectSave,
        )
        .then((response) => {
          if (response.response) {
            this.MensagemError(
              `Falha ao Inserir o campo ${response.response.data.errors[0].fieldName}`,
              `${response.response.data.errors[0].message}`,
            );
            this.showForm = true;
            return;
          }
          this.showMessageSuccess("Salvo", "Incluido com sucesso!");
          this.cancelar();
        });
    },
    async remove(data) {
      this.$swal({
        title: "Remover o registro?",
        text: "Está ação não poderá ser desfeita",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Remover",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("parcelamentoFinananceiroModule/delete", data.id)
            .then((response) => {
              if (response.data.error) {
                this.MensagemError(
                  "Falha ao remover o registro",
                  response.data.message,
                );
                return;
              }
              this.showMessageSuccess(
                "Remover",
                "Registro removido com sucesso!",
              );
              this.pageConfig.sort = this.sortName;
              this.loadTable(this.module, this.pageConfig);
            })
            .catch((err) => {
              this.MensagemError("Falha ao remover o registro", err.message);
              this.pageConfig.sort = this.sortName;
              this.loadTable(this.module, this.pageConfig);
            });
        }
      });
    },
  },
};
</script>
